/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompaniesResponseCompanyName
 */
export interface CompaniesResponseCompanyName {
    /**
     * グループコード
     * @type {string}
     * @memberof CompaniesResponseCompanyName
     */
    companyCode: string;
    /**
     * 無線グループ名
     * @type {string}
     * @memberof CompaniesResponseCompanyName
     */
    groupName: string;
    /**
     * 名称
     * @type {string}
     * @memberof CompaniesResponseCompanyName
     */
    name: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof CompaniesResponseCompanyName
     */
    companyId: string;
    /**
     * 区分(法人/個人):1:法人, 2:個人事業主
     * @type {number}
     * @memberof CompaniesResponseCompanyName
     */
    businessType: number;
    /**
     * 会社所在地
     * @type {string}
     * @memberof CompaniesResponseCompanyName
     */
    address?: string;
}

/**
 * Check if a given object implements the CompaniesResponseCompanyName interface.
 */
export function instanceOfCompaniesResponseCompanyName(value: object): value is CompaniesResponseCompanyName {
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('businessType' in value) || value['businessType'] === undefined) return false;
    return true;
}

export function CompaniesResponseCompanyNameFromJSON(json: any): CompaniesResponseCompanyName {
    return CompaniesResponseCompanyNameFromJSONTyped(json, false);
}

export function CompaniesResponseCompanyNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompaniesResponseCompanyName {
    if (json == null) {
        return json;
    }
    return {
        
        'companyCode': json['company_code'],
        'groupName': json['group_name'],
        'name': json['name'],
        'companyId': json['company_id'],
        'businessType': json['business_type'],
        'address': json['address'] == null ? undefined : json['address'],
    };
}

export function CompaniesResponseCompanyNameToJSON(json: any): CompaniesResponseCompanyName {
    return CompaniesResponseCompanyNameToJSONTyped(json, false);
}

export function CompaniesResponseCompanyNameToJSONTyped(value?: CompaniesResponseCompanyName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_code': value['companyCode'],
        'group_name': value['groupName'],
        'name': value['name'],
        'company_id': value['companyId'],
        'business_type': value['businessType'],
        'address': value['address'],
    };
}

